import { combineEpics } from 'redux-observable'
import { connectivityEpic } from './ConnectivityEpic.js'

export const connectivityEpics = combineEpics(connectivityEpic)
